import { render, staticRenderFns } from "./InvitationCardWrapper.vue?vue&type=template&id=53dbd07c&"
import script from "./InvitationCardWrapper.vue?vue&type=script&lang=js&"
export * from "./InvitationCardWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports